var sika = sika || {};
( function () {
    'use strict';
    jQuery( window ).scroll( function () {
        var scroll = jQuery( window ).scrollTop();
        if ( scroll >= 500 ) {
            jQuery( '.e-header' ).addClass( 'sika-header-scroll-background' );
        }
        else {
            jQuery( '.e-header' ).removeClass( 'sika-header-scroll-background' );
        }
    } );
    jQuery( function () {
        sika.initOnReady();
        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', sika.productsheet.init );
    } );
    jQuery( window ).on( 'load', function () {
        sika.initOnLoad();
    } );
    jQuery( '.e-dropdown-mega .dropdown-toggle' ).click( function ( event ) {
        jQuery( '.e-header' ).toggleClass( 'sika-header-background' );
    } );
    jQuery( document ).click( function ( e ) {
        if ( !jQuery( e.target ).closest( '.e-header .sika-header-background' ).length ) {
            jQuery( '.sika-header-background' ).toggleClass( 'sika-header-background' );
        }
    } );
    sika.initOnReady = function () {
        sika.video.fit();
        sika.forms.init();
        sika.ecom.init();
        //        sika.frontpageTiles.init();
    };
    sika.initOnLoad = function () {
        sika.video.play();
        sika.nav();
        sika.shoefinder.init();
        sika.favorites.init();
        if ( jQuery( '.js-e-product' ).length ) {
            sika.productsheet.init(); //Productlist pdf script inited in ecom.productlist.js
        }
    };
    sika.utils = {
        isTouchDevice: function () {
            return 'ontouchstart' in window || navigator.maxTouchPoints;
        }
    };
    sika.video = {
        fit: function () {
            var jVideo = jQuery( '.js-sika-video-movie' );
            if ( jVideo.length > 0 ) {
                objectFitPolyfill( jVideo );
            }
        },
        play: function () {
            var jVideo = jQuery( '.js-sika-video-movie' );
            if ( jVideo.length > 0 ) {
                jVideo.addClass( 'is-ready' );
                jVideo.get( 0 ).play();
            }
        }
    };
    sika.forms = {
        addEms: function ( jForm ) {
            var formData = eval( jQuery( '#extended-form-data' ).html() ),
                    jOptions = '';
            for ( var i = 0; i < formData.length; i++ ) {
                jOptions += '<option value="' + formData[ i ].em + '">' + formData[ i ].nm + '</option>';
            }
            jForm.find( 'select[name="Recipient"]' ).addClass( 'js-extended-form-recipient' ).html( jOptions );
            sika.forms.emsActions();
            sika.forms.emsSubmit();
        },
        emsActions: function () {
            jQuery( 'form.js-extended-form-with-reciepients' ).on( 'change', '.js-extended-form-recipient', function () {
                jQuery( 'input[type="hidden"][name="MailRecipient"]' ).val( jQuery( this ).val() );
            } ).trigger( 'change' );

        },
        emsSubmit: function () {
            jQuery( 'form.js-extended-form-with-reciepients' ).find( 'button[type="submit"]' ).on( 'click', function () {
                if ( jQuery( 'form.js-extended-form-with-reciepients' ).valid() ) {
                    var emsRecp = jQuery( 'form.js-extended-form-with-reciepients' ).find( 'input[type="hidden"][name="MailRecipient"]' );
                    emsRecp.val( emsRecp.val().replace( '$', '@' ).replace( /\+/g, '.' ).replace( /!/g, 'h' ).replace( /\*/g, 's' ) );
                }
            } );
        },
        init: function () {
            var jForm = jQuery( 'form.js-extended-form-with-reciepients' );
            if ( jForm.find( 'select[name="Recipient"]' ).length ) {
                sika.forms.addEms( jForm );
            }

        }
    };
    sika.nav = function () {
        var arrLocationPath = location.pathname.replace( /^\//, '' ).split( '/' ),
                jNav = jQuery( '.js-e-nav-utilities-primary' ),
                jNavActive = jNav.find( '.nav-link[href^="/' + arrLocationPath[ 0 ] +
                                        '"]' );
        if ( jNavActive.length === 0 || arrLocationPath[ 0 ] === '' ) {
            jNavActive = jNav.find( '.nav-item:first-child' ).find( '.nav-link' );
        }
        jNavActive.addClass( 'is-inpath' );
    };
    //    sika.frontpageTiles = {
    //        init: function () {
    //            jQuery( '.bubble-frontpage-tiles .p-tile' ).hover( function () {
    //                jQuery( this ).siblings( 'div' ).children( '.p-tile-container' ).addClass( 'js-sika-tiles-hovered-siblings' );
    //            }, function () {
    //                jQuery( this ).siblings( 'div' ).children( '.p-tile-container' ).removeClass( 'js-sika-tiles-hovered-siblings' );
    //            } );
    //        }
    //    };
    
}() );
// https://github.com/constancecchen/object-fit-polyfill
// http://walterebert.com/blog/html5-video-autoplay-mobile-revisited/
